{
  "slug": "light-yagami-iq",
  "title": "Light Yagami IQ: can a fictional character have a score?",
  "description": "Separate Light Yagami’s documented fictional characterization from unsupported online IQ numbers and psychometric claims.",
  "summary": "Light Yagami is portrayed as a highly capable student and strategist in Death Note. Because he is fictional and has no standardized assessment record, an exact IQ cannot be verified.",
  "category": "Famous people and IQ claims",
  "sections": [
    {
      "heading": "What the source material establishes",
      "paragraphs": [
        "Official descriptions present Light as an exceptional student placed in a strategic conflict. The story demonstrates planning, deception, deduction, and adaptation under fictional conditions.",
        "Those traits are part of characterization. They do not supply raw responses, standardized instructions, age norms, or a controlled testing session."
      ]
    },
    {
      "heading": "Why exact values circulate",
      "paragraphs": [
        "Fan comparisons often rank characters by impressive feats and then attach precise numbers. That method has no validated mapping to an intelligence scale and usually provides no primary score record.",
        "Different writers can also portray a character inconsistently. Narrative success depends on plot information and author decisions, not only cognitive ability."
      ]
    },
    {
      "heading": "Evidence-aware conclusion",
      "paragraphs": [
        "It is fair to analyze the kinds of reasoning shown in the series. It is not accurate to claim that those scenes establish a clinical IQ.",
        "Any precise Light Yagami IQ number should be labeled as speculation rather than canon or psychological measurement."
      ]
    }
  ],
  "faqs": [
    {
      "question": "Does Death Note give Light Yagami an IQ?",
      "answer": "No authenticated standardized score is established by the official source referenced here."
    },
    {
      "question": "Can fictional feats be converted into IQ points?",
      "answer": "No validated method converts scripted accomplishments into a standardized human assessment score."
    }
  ],
  "related": ["patrick-jane-iq", "iq-vs-intelligence", "highest-iq-ever-recorded"],
  "sources": [
    {
      "label": "VIZ — official Death Note overview",
      "url": "https://www.viz.com/death-note"
    }
  ]
}
